import { SEO } from "@/components/SEO";
export const HeroSection = () => {
  const forProsSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Join Home Pros OKC - For Service Professionals",
    "description": "Join Oklahoma City's premier network of trusted home service professionals. Get listed today to connect with homeowners and grow your business.",
    "provider": {
      "@type": "Organization",
      "name": "Home Pros OKC",
      "url": "https://homeprosokc.com"
    }
  };
  return <>
      <SEO title="Join Our Network - For Service Professionals | Home Pros OKC" description="Join Oklahoma City's premier network of trusted home service professionals. Get listed today to connect with homeowners and grow your business." canonicalUrl="/for-pros" schema={forProsSchema} />
      <div className="bg-gradient-to-b from-primary/10 to-background py-8 md:py-12">
        <div className="container mx-auto px-4 max-w-4xl text-center">
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-primary">Grow Your Home Service Business with
Home Pros OKC</h1>
          <p className="text-lg mb-4 text-muted-foreground max-w-2xl mx-auto">Join Oklahoma City's premier network of trusted home service professionals. Get listed today for free!</p>
        </div>
      </div>
    </>;
};